import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const svas = [
  { 
    name: "HBO Max", 
    logo: "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/nuqxdamp_unnamed.png"
  },
  { 
    name: "Sky+", 
    logo: "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/sv1pmudd_WhatsApp%20Image%202026-03-04%20at%2017.24.30.jpeg"
  },
  { 
    name: "Deezer", 
    logo: "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/d297y22f_WhatsApp%20Image%202026-03-04%20at%2017.24.30-2.jpeg"
  },
  { 
    name: "Kaspersky", 
    logo: "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/l1rdbdqf_WhatsApp%20Image%202026-03-04%20at%2017.24.31.jpeg"
  },
  { 
    name: "Docway", 
    logo: "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/cry2en05_WhatsApp%20Image%202026-03-04%20at%2017.24.31-2.jpeg"
  },
  { 
    name: "Ubook", 
    logo: "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/jcybmetq_images.png"
  },
];

const SVAsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="svas"
      className="py-20 lg:py-32 bg-brand-dark relative overflow-hidden"
      data-testid="svas-section"
      ref={ref}
    >
      {/* Background accent */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-ruby to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          className="text-center max-w-3xl mx-auto mb-12 lg:mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-2 bg-brand-ruby/10 text-brand-ruby text-sm font-bold tracking-wider uppercase rounded-full mb-4">
            SVAs - Benefícios
          </span>
          <h2 className="font-montserrat font-black text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight mb-4">
            Muito mais que conectividade,
            <br />
            <span className="text-brand-ruby">um ecossistema de benefícios</span>
          </h2>
          <p className="text-white/60 text-base sm:text-lg">
            Serviços de valor agregado inclusos nos planos premium
          </p>
        </motion.div>

        {/* SVAs Grid with Logos */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-6">
          {svas.map((sva, index) => (
            <motion.div
              key={sva.name}
              className="group flex flex-col items-center justify-center p-4 lg:p-6 bg-brand-gray/50 border border-white/10 rounded-2xl hover:border-brand-ruby/30 transition-all duration-300"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`sva-${index}`}
            >
              <div className="w-20 h-20 lg:w-24 lg:h-24 rounded-xl overflow-hidden flex items-center justify-center mb-3 transition-transform group-hover:scale-110">
                <img
                  src={sva.logo}
                  alt={sva.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-white/80 text-sm font-medium text-center">
                {sva.name}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Info Note */}
        <motion.div
          className="text-center mt-10"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <p className="text-white/50 text-sm">
            * Disponibilidade dos SVAs varia de acordo com o plano contratado
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default SVAsSection;
